import React, { useEffect, useState } from 'react'
import { Select,Form, Space} from 'antd';
import { useBnsGongNengListQuery } from '../../store/BnsKeJiApi';
import ModuleList from './ModuleList';
function ModuleSelect(props) {
    const [list, setList] = useState();    
    const {data, isSuccess} = useBnsGongNengListQuery({bgn_bg_id:props.bgn_bg_id},{skip:!props.bgn_bg_id});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bgn_id:key,bgn_name} = item;
                    return item = {value:key,label:bgn_name}
                })                
                setList(newArr)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])
    return (
        <Form.Item
            label={props.label}
            wrapperCol={props.wrapperCol}
            required={props.required}
            style={props.FormStyle}
        >
            <Space>
                <Form.Item
                    name={props.name}
                    style={{marginBottom:"0"}}
                >
                    <Select
                        options={list}
                        onChange={(e,f) => {props.onChange(e,f)}}
                        showSearch
                        optionFilterProp="label"
                        placeholder={props.placeholder}
                        style={props.style}
                    />
                </Form.Item>
                <ModuleList bg_id={props.bgn_bg_id}  bg_name={props.bgn_bg_name}/>
            </Space>
        </Form.Item>
    )
}

export default ModuleSelect